/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Role {
    USER = 'USER',
    ADMIN = 'ADMIN',
    CUSTOMER_ADMIN = 'CUSTOMER_ADMIN',
    SUPER_ADMIN = 'SUPER_ADMIN',
}
